import ProgressBar from './ProgressBar';
import './ProgressBar.less'

export default ProgressBar;
